// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c9d6cb0e","963":"00a29a23"}[chunkId] + ".chunk.js";
};